if (!customElements.get('product-ring-size-engraving')) {
  const selectedSizes = new Map();
  class ProductRingSizeEngraving extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound === 'true') return;
      this.dataset.bound = 'true';

      this.maxChars = Number(this.dataset.maxChars || 20);
      this.sizeEmptyLabel =
        this.querySelector('[data-rse-open="size"] [data-rse-size-display]')?.textContent?.trim() ||
        'Select Size';
      this.emptyLabel =
        this.querySelector('[data-rse-engraving-display]')?.textContent?.trim() || 'Add Engraving';
      this.selectedFont = this.querySelector('.engraving-font-pill.is-active')?.dataset.rseFont || '';
      this.selectedFontFamily =
        this.querySelector('.engraving-font-pill.is-active')?.dataset.rseFontFamily || '';
      this.selectedFontTransform =
        this.querySelector('.engraving-font-pill.is-active')?.dataset.rseFontTransform || 'none';

      this.onDocClick = this.onDocClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);

      this.querySelectorAll('[data-rse-open]').forEach((btn) => {
        btn.addEventListener('click', () => this.openModal(btn.dataset.rseOpen));
      });

      this.querySelectorAll('[data-rse-close]').forEach((btn) => {
        btn.addEventListener('click', () => this.closeModals());
      });

      this.querySelectorAll('[data-rse-modal]').forEach((modal) => {
        modal.addEventListener('click', (event) => {
          if (event.target === modal) this.closeModals();
        });
      });

      this.querySelectorAll('[data-rse-size-value]').forEach((pill) => {
        pill.addEventListener('click', () => this.selectSize(pill));
      });

      this.querySelectorAll('[data-rse-font]').forEach((pill) => {
        pill.setAttribute('aria-pressed', String(pill.classList.contains('is-active')));
        pill.setAttribute('aria-label', pill.dataset.rseFont || pill.textContent.trim());
        pill.addEventListener('click', () => this.selectFont(pill));
      });

      const input = this.querySelector('[data-rse-engraving-input]');
      if (input) {
        input.addEventListener('input', () => this.syncPreview());
      }

      this.querySelector('[data-rse-engraving-done]')?.addEventListener('click', () => {
        this.commitEngraving();
        this.closeModals();
      });

      this.querySelector('[data-rse-engraving-clear]')?.addEventListener('click', () => {
        this.clearEngraving();
      });

      this.syncPreview();
      this.specSection = this.closest('.section-main-product');
      this.onSpecChange = () => this.syncSpecs();
      this.specSection?.addEventListener('change', this.onSpecChange);
      this.syncSpecs();
      const productUrl = new URL(this.dataset.productUrl || '/', window.location.origin);
      this.sizeProductKey = productUrl.pathname;
      const pageUrl = new URL(window.location.href);
      const sizeFromUrl = pageUrl.pathname === productUrl.pathname ? pageUrl.searchParams.get('ring_size') : '';
      const requestedSize = selectedSizes.get(this.sizeProductKey) || sizeFromUrl;
      if (requestedSize) {
        const pill = Array.from(this.querySelectorAll('[data-rse-size-value]')).find(el => el.dataset.rseSizeValue === requestedSize);
        if (pill) this.selectSize(pill);
      }
      window.AiminiaRingSize?.sync();
      if (pageUrl.searchParams.get('choose_size') === '1' && !requestedSize) this.openModal('size');
    }

    syncSpecs() {
      this.querySelectorAll('[data-aiminia-spec-option]').forEach((target) => {
        const name = target.dataset.aiminiaSpecOption;
        const checked = Array.from(this.specSection?.querySelectorAll('variant-selects input:checked') || []).find(input => input.name === name);
        if (checked) target.textContent = (checked.dataset.displayValue || checked.value).trim();
      });
      const size = this.querySelector('[data-rse-size-property]')?.value;
      const sizeTarget = this.querySelector('[data-aiminia-spec-size]');
      if (sizeTarget) sizeTarget.textContent = size ? 'US ' + size : 'Select a size above';
    }

    disconnectedCallback() {
      this.specSection?.removeEventListener('change', this.onSpecChange);
      document.removeEventListener('click', this.onDocClick, true);
      document.removeEventListener('keydown', this.onKeydown);
    }

    openModal(name) {
      const modal = this.querySelector(`[data-rse-modal="${name}"]`);
      if (!modal) return;
      if (!this.activeModal) this.returnFocus = document.activeElement;
      this.closeModals(false);
      this.activeModal = modal;
      modal.hidden = false;
      requestAnimationFrame(() => {
        modal.classList.add('is-open');
        requestAnimationFrame(() => {
          if (modal.classList.contains('is-open')) modal.querySelector('input, button')?.focus();
        });
      });
      document.documentElement.classList.add('rse-modal-open');
      document.addEventListener('keydown', this.onKeydown);
    }

    closeModals(restoreFocus = true) {
      this.querySelectorAll('[data-rse-modal]').forEach((modal) => {
        modal.classList.remove('is-open');
        window.setTimeout(() => {
          if (!modal.classList.contains('is-open')) modal.hidden = true;
        }, 220);
      });
      document.documentElement.classList.remove('rse-modal-open');
      document.removeEventListener('keydown', this.onKeydown);
      this.activeModal = null;
      if (restoreFocus && this.returnFocus?.isConnected) this.returnFocus.focus();
    }

    onKeydown(event) {
      if (event.key === 'Escape') { event.preventDefault(); this.closeModals(); }
      if (event.key === 'Tab' && this.activeModal) {
        const items = Array.from(this.activeModal.querySelectorAll('a[href], button:not(:disabled), input:not(:disabled), [tabindex="0"]')).filter(el => el.getClientRects().length);
        const first = items[0], last = items[items.length - 1];
        if (!this.activeModal.contains(document.activeElement)) { event.preventDefault(); first?.focus(); }
        else if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }
    }

    onDocClick() {}

    selectSize(pill) {
      const value = pill.dataset.rseSizeValue || '';
      if (this.sizeProductKey) selectedSizes.set(this.sizeProductKey, value);
      this.querySelectorAll('[data-rse-size-value]').forEach((el) => {
        const active = el === pill;
        el.classList.toggle('is-selected', active);
        el.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      const display = this.querySelector('[data-rse-size-display]');
      if (display) display.textContent = value ? 'US ' + value : this.sizeEmptyLabel;

      const trigger = this.querySelector('[data-rse-open="size"]');
      trigger?.classList.toggle('selected', Boolean(value));

      const prop = this.querySelector('[data-rse-size-property]');
      if (prop) prop.value = value;
      this.querySelector('[data-rse-size-error]')?.setAttribute('hidden', '');
      trigger?.removeAttribute('aria-invalid');
      this.dispatchEvent(new CustomEvent('rse:size-changed', { bubbles: true }));
      this.syncSpecs();

      this.closeModals();
    }

    selectFont(pill) {
      this.querySelectorAll('[data-rse-font]').forEach((el) => {
        el.classList.toggle('is-active', el === pill);
        el.setAttribute('aria-pressed', String(el === pill));
      });
      this.selectedFont = pill.dataset.rseFont || '';
      this.selectedFontFamily = pill.dataset.rseFontFamily || '';
      this.selectedFontTransform = pill.dataset.rseFontTransform || 'none';
      this.syncPreview();
    }

    syncPreview() {
      const input = this.querySelector('[data-rse-engraving-input]');
      const preview = this.querySelector('[data-rse-preview-text]');
      const counter = this.querySelector('[data-rse-counter]');
      const text = (input?.value || '').slice(0, this.maxChars);

      if (input && input.value !== text) input.value = text;
      if (counter) counter.textContent = `${text.length}/${this.maxChars}`;
      if (preview) {
        preview.textContent = text;
        preview.style.fontFamily = this.selectedFontFamily || '';
        preview.style.textTransform = this.selectedFontTransform || 'none';
      }
    }

    commitEngraving() {
      const input = this.querySelector('[data-rse-engraving-input]');
      const text = (input?.value || '').trim().slice(0, this.maxChars);
      const display = this.querySelector('[data-rse-engraving-display]');
      const trigger = this.querySelector('[data-rse-open="engraving"]');
      const textProp = this.querySelector('[data-rse-engraving-property]');
      const fontProp = this.querySelector('[data-rse-font-property]');

      if (textProp) textProp.value = text;
      if (fontProp) fontProp.value = text ? this.selectedFont : '';

      if (display) {
        display.textContent = text ? `“${text}”` : this.emptyLabel;
      }
      trigger?.classList.toggle('set', Boolean(text));
    }

    clearEngraving() {
      const input = this.querySelector('[data-rse-engraving-input]');
      if (input) input.value = '';
      this.syncPreview();
      this.commitEngraving();
      this.closeModals();
    }
  }

  customElements.define('product-ring-size-engraving', ProductRingSizeEngraving);
}
